module.exports = __webpack_public_path__ + "static/assets/76081e0046c4862c07bb3494ae5f5b3b.gif";